import { render } from "./cod-cancel-value-card.vue?vue&type=template&id=60ba7e50&scoped=true&ts=true"
import script from "./cod-cancel-value-card.vue?vue&type=script&lang=ts"
export * from "./cod-cancel-value-card.vue?vue&type=script&lang=ts"

import "./cod-cancel-value-card.vue?vue&type=style&index=0&id=60ba7e50&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ba7e50"]])

export default __exports__